import styled from "styled-components";
import Spring from "../../components/Spring";

export const StyledPasswordRecovery = styled(Spring)`
    overflow: hidden;
    background-color: ${p => p.theme.c.snow};
    min-height: calc(100vh - 50px);
    display: block;

    &.Flex {
        display: flex;
    }
`;

export const FormWrapper = styled.div`
    max-width: 480px;
    margin: auto;
    height: 100%;
    position: relative;
`;

export const SuccessScreen = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    p {
        text-align: center;
    }
`;
